<template>
  <div>
    <div v-if="!photo_url || photo_url.length<=1">
      <v-file-input @change="oneExecution.done_items[question].photo_original? $refs.iup1.handleFile(oneExecution.done_items[question].photo_original) : null" 
        prepend-icon="mdi-camera" v-model="oneExecution.done_items[question].photo_original" show-size capture="camera" accept="image/png, image/jpeg" label="Foto"
        @click:clear="clearPhoto"
        color="secondary"
        :disabled="oneExecution.done_items[question].approval_status == 'approved'"
      ></v-file-input>
    </div>

    <div v-if="((all_photo_url && Array.isArray(all_photo_url)))">
      <carousel-photos :photos="all_photo_url" allow_delete @photoToDelete='handlePhotoToDelete'></carousel-photos>
    </div>
    
    <image-uploader
      :id="'bacon1'"
      ref="iup1"
      :debug="0"
      :autoRotate="false"
      outputFormat="verbose"
      :preview="false"
      capture="environment"
      accept="image/png, image/jpeg"
      :maxWidth="800"
      :quality='0.8'
      doNotResize="['gif', 'svg']"
      @input="setImage2"
      style="display:none"
    >
      <label for="fileInput" slot="upload-label">
        <v-icon large>mdi-camera</v-icon>
        <span class="upload-caption">{{
          hasImage ? "Replace" : "Click to upload"
        }}</span>
      </label>
    </image-uploader>


    <dialog-loading v-if="loading" :loadingText="loadingText"></dialog-loading>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CarouselPhotos from '../../../components/forms/show/done_form/done_item/CarouselPhotos.vue'

export default {
  components: { CarouselPhotos },
  props: {
    is_partial: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      key: null,
      // oneExecution.done_items[question]: this.$attrs.item,

      hasImage: null,
      image: null,

      loading: false,
      loadingText: null,
    }
  },
  methods: {
    handlePhotoToDelete(e){
      let {idx, id} = e
      let {photo_ids, photo_compressed_partial} = this.oneExecution.done_items[this.question]

      let has_id_and_is_equal = ((id && photo_compressed_partial[idx].id == id) || !id)
      
      if (photo_ids && photo_ids[idx] && has_id_and_is_equal){
        this.oneExecution.done_items[this.question].photo_compressed_attachments_attributes = [{
          id: photo_ids[idx], _destroy: true
        }]
        this.oneExecution.done_items[this.question].photo_compressed_partial.splice(idx, 1)
        this.oneExecution.done_items[this.question].photo_ids.splice(idx, 1)
        if (Array.isArray(this.photo_comp_aux)){
          this.oneExecution.done_items[this.question].photo_compressed.splice(idx, 1)
        }
      } else if (!photo_ids || !photo_ids[idx]){
        if (!Array.isArray(this.photo_comp_aux) && this.photo_comp_aux ){
          this.clearPhoto()
        }
      }
    },
    clearPhoto(){
      this.loading = true
      this.oneExecution.done_items[this.question].photo_original = null
      this.oneExecution.done_items[this.question].photo_compressed = null
      if (this.oneExecution.done_items[this.question].photo == 2) {
        this.oneExecution.done_items[this.question].answer = null
      }
      this.loading = false
    },
    setImage2: function(output) {
      this.loading = true
      this.loadingText = 'Carregando'
      this.oneExecution.done_items[this.question].photo_compressed = null;
      setTimeout(() => {
        if (['png', 'jpg', 'jpeg'].includes((output.type || output.info.type).split('/').slice(-1)[0])){
          this.hasImage = true;
          this.image = output.dataUrl;
          this.oneExecution.done_items[this.question].photo_compressed=output
          this.oneExecution.done_items[this.question].photo_compressed.data = output.dataUrl
          this.oneExecution.done_items[this.question].photo_compressed.filename = output.info.name
          this.oneExecution.done_items[this.question].photo_compressed.content_type = output.info.type
  
          this.oneExecution.done_items[this.question].answer_changed = true
          this.updateDoneItemOnlyIdb(this.oneExecution.done_items[this.question])
        } else {
          alert('Tipo de arquivo não suportado!\nUtilize por favor imagem PNG ou JPEG/JPG.')
          this.clearPhoto()
        }
        
        this.loading = false
        this.loadingText = null
           // auto-comment// console.log(this.image);
      }, 1500);
         // auto-comment// console.log(this.$refs);
    },
    ...mapActions({
      updateDoneItemOnlyIdb: 'Execution/updateDoneItemOnlyIdb',
      // function: 'Module/action'
    })
  },
  mounted () {
    if (this.oneExecution.done_items[this.question].photo_original){
      // delete this.oneExecution.done_items[this.question].photo_compressed
      // delete this.oneExecution.done_items[this.question].photo_original
    }
    // this.oneExecution.done_items[this.question].photo_original = ''
  },
  computed: {
    photo_url() {
      if (this.oneExecution.is_partial /*&& !this.oneExecution.done_items[this.question].photo_original*/)
        return this.oneExecution.done_items[this.question].photo_compressed_partial

      return null
    },
    
    photo_comp_aux(){
      if (this.loading){

      }
      return this.oneExecution.done_items[this.question].photo_compressed
    },
    photo_orig_aux(){
      return this.oneExecution.done_items[this.question].photo_original
    },
    photo_ids(){
      return this.oneExecution.done_items[this.question].photo_ids
    },
    all_photo_url(){
      let p = [...( this.photo_url || [] )]
      if (this.photo_comp_aux){
        let new_pc = []
        if (Array.isArray(this.photo_comp_aux)){
          new_pc = [...this.photo_comp_aux]
          p = [...p, ...new_pc]
          p = p.filter((pp, idx, arr)=>{
            if (pp.id){
              if (arr.map(a=> a.id).indexOf(pp.id) === idx){
                return pp 
              }
            } else {
              return pp
            }
          })
          p = [...new Set(p)];
        } else if (typeof(this.photo_comp_aux)=='object'){
          new_pc = this.photo_comp_aux.dataUrl
          // console.log({new_pc});
          p = [...p, new_pc]
        }
      }
      return p
    },
    ...mapState({
      question: state => state.Execution.question,
      oneExecution: state => state.Execution.oneExecution,
    })
  },
  watch: {
    photo_comp_aux(nv,ov) {
         // auto-comment// console.log({nv});
      if (nv){
        setTimeout(() => {
          this.loading = false
          this.loadingText = null
        }, 1200);

      } else if (nv == false){
      }
      // ! REPETIR PARA TODOS OS ITEMS
      this.oneExecution.done_items[this.question].answer_changed = true
      this.updateDoneItemOnlyIdb(this.oneExecution.done_items[this.question])
    },
    photo_orig_aux(nv,ov) {
          // console.log({nv});
      if (nv){
        // setTimeout(() => {
          // this.loading = false
          // this.loadingText = null
        // }, 1200);

      } else if (nv == null || nv == ''){
            // console.log('is null');
        
        this.oneExecution.done_items[this.question].photo_compressed = ''
      }
      // ! REPETIR PARA TODOS OS ITEMS
      // this.oneExecution.done_items[this.question].answer_changed = true
      // this.updateDoneItemOnlyIdb(this.oneExecution.done_items[this.question])
    }
  },
}
</script>

<style scoped>

</style>